import { endOfDay, startOfDay } from 'date-fns'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { DESC_ORDER_SYMBOL } from '../../../../../constants/sort'
import { APPLICANTS_FILTER_PARAM } from '../../../../RentalPortalApplicant'
import { APPLICANT_COLUMN_NAME } from '../../RentalPortalApplicants.constants'

export const EMPTY_ITEMS = {
  items: EMPTY_LIST,
  permissions: EMPTY_OBJECT,
}

export const APPLICANTS_API_DEFAULT_ORDERING = [
  `${DESC_ORDER_SYMBOL}received_at`,
]

export const APPLICANTS_API_ORDERING_FIELD = {
  [APPLICANT_COLUMN_NAME.Listing]: 'listing',
  [APPLICANT_COLUMN_NAME.Portal]: 'source',
  [APPLICANT_COLUMN_NAME.Received]: 'received_at',
  [APPLICANT_COLUMN_NAME.Reference]: 'reference',
  [APPLICANT_COLUMN_NAME.Stage]: 'stage',
}

export const APPLICANTS_API_LIST_FILTER = {
  [APPLICANTS_FILTER_PARAM.listing]: 'listing',
  [APPLICANTS_FILTER_PARAM.source]: 'source',
  [APPLICANTS_FILTER_PARAM.stage]: 'stage',
}

export const APPLICANTS_API_VALUE_FILTER = {
  [APPLICANTS_FILTER_PARAM.receivedGte]: 'received_at_gte',
  [APPLICANTS_FILTER_PARAM.receivedLte]: 'received_at_lte',
}

export const APPLICANTS_API_DAY_BOUNDARY = {
  [APPLICANTS_FILTER_PARAM.receivedGte]: startOfDay,
  [APPLICANTS_FILTER_PARAM.receivedLte]: endOfDay,
}
